// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.flex-item {
  padding: 5px;
  width: 600px;
  min-width: 320px;
}

.heading {
  padding-left: 95px !important;
}

.shortdec {
  margin-left: 100px !important;
}

.moveleft {
  margin-left: 82px;
}

.bannerHeader {
  margin-left: 90px;
}

.benefitContent {
  margin-left: 100px;
}

.tabrow {
  margin-left: 100px !important;
  position: relative;
}

@media only screen and (max-width: 768px) {
  .bannerNameSectionSmall {
    margin-left: 21px;
  }
}
@media (max-width: 1024px) {
  .heading {
    padding-left: 25px !important;
  }
  .tabrow {
    margin-left: 0px !important;
  }
  .shortdec {
    margin-left: -1px !important;
  }
  .moveleft {
    margin-left: 0px;
  }
  .bannerHeader {
    margin-left: 0px;
  }
  .benefitContent {
    margin-left: 0px;
  }
  .helper-text {
    left: 15px !important;
  }
}
.success-icon {
  float: left;
  padding-top: 5px;
}

.programs-heading {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-medium) var(--unnamed-font-size-18)/var(--unnamed-line-spacing-21) var(--unnamed-font-family-attalecksans-medium);
  letter-spacing: var(--unnamed-character-spacing-0-6);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal medium 18px/21px ATTAleckSans-Medium;
  letter-spacing: 0.6px;
  color: #000000;
  opacity: 1;
}

.programs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.programs-note {
  font-size: 14px;
}
@media only screen and (max-width: 768px) {
  .programs-note {
    font-size: 12px;
    margin-left: 10px;
  }
}

.program {
  margin: 12px;
  max-width: 340px;
}

.program-img {
  height: 169px;
  object-fit: cover;
}

.programsEfotaImage {
  flex: 0 0 auto;
}
.programsEfotaImage img {
  height: 258px;
  object-fit: cover;
  object-position: right;
  width: 596px;
}

.programsEfotaText {
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 0 0 0 15px;
  max-width: 596px;
}

.program-title {
  font: 30px "Omnes-ATT-W02-Medium";
}
@media (max-width: 1024px) {
  .program-title {
    font: 28px "Omnes-ATT-W02-Medium";
  }
}
@media only screen and (max-width: 768px) {
  .program-title {
    font: 24px "Omnes-ATT-W02-Medium";
  }
}

.program-details {
  font-size: 16px;
}

.programs-efota {
  align-items: center;
  background: var(--unnamed-color-f2f2f2) 0% 0% no-repeat padding-box;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 0;
  padding: 46px 0 46px 0;
  width: 100%;
}

.programsEfotaTextTitle {
  font: 28px "Omnes-ATT-W02-Medium";
}

.gettingStartedHeader {
  max-width: 217px;
  font-size: 30px;
  line-height: 40px;
  float: left;
  letter-spacing: 0.81px;
  color: #000000;
  opacity: 1;
}
@media (max-width: 1024px) {
  .gettingStartedHeader {
    font-size: 20px;
    max-width: 100%;
    margin-left: 10px;
    line-height: 30px;
  }
}

.tabslistsection {
  max-height: 70px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  overflow: hidden;
  position: relative;
  width: 99.4vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
.tabslistsection .tabslistrow {
  padding-top: 20px;
  margin-right: auto;
  margin-left: 9%;
  font-size: 18px;
}
@media (max-width: 1024px) {
  .tabslistsection .tabslistrow {
    font-size: 8px !important;
    margin-top: 10px !important;
    margin-left: 8px;
  }
}
.tabslistsection .tabitem {
  margin-right: 45px;
  padding-left: 0px;
}
@media (max-width: 1024px) {
  .tabslistsection .tabitem {
    font-size: 14px;
    margin-right: 30px;
  }
}
@media only screen and (max-width: 768px) {
  .tabslistsection .tabitem {
    font-size: 12px;
    margin-right: 3px;
  }
}
.tabslistsection .tabitem:hover {
  cursor: pointer;
}
.tabslistsection .tabline {
  background-color: #0469AE;
  padding-bottom: -20px;
  opacity: 1;
  width: 81px;
  height: 5px;
  margin-top: 25px;
  margin-right: auto;
  margin-left: 9%;
  padding-left: 15px;
  float: left;
}
@media (max-width: 1024px) {
  .tabslistsection .tabline {
    width: 0px;
    border: 0px;
    visibility: hidden;
  }
}

.shortdescription {
  padding-top: 52px;
  max-width: 1217px;
  margin-left: 100px;
}
@media (max-width: 1024px) {
  .shortdescription {
    padding-top: 14px;
    font-size: 18px;
    margin-left: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .shortdescription {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .title-heading {
    margin-left: 10px !important;
    margin-top: 10px !important;
  }
}
.shortdescription1 {
  padding-top: 15px;
  max-width: 1217px;
  margin-bottom: 30px;
  padding-left: 8%;
}
@media (max-width: 1024px) {
  .shortdescription1 {
    padding-top: 14px;
    padding-left: 3%;
  }
}

:host ::ng-deep body {
  font-size: 20pt/28pt !important;
}

.benefitsheader {
  padding-top: 30px;
  font-size: 28pt !important;
  max-width: 50%;
  float: left;
  margin-left: 0%;
}
@media (max-width: 1024px) {
  .benefitsheader {
    max-width: 100%;
    padding-top: 20px;
  }
}
.benefitsheader .benefitsheaderpara {
  font-size: 30px;
  float: left;
  line-height: 23px;
}
@media (max-width: 1024px) {
  .benefitsheader .benefitsheaderpara {
    font-size: 28px;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .benefitsheader .benefitsheaderpara {
    font-size: 24px;
  }
}

.benefits {
  padding-top: -30px;
  max-width: 1217px;
  padding-bottom: 480px;
  display: flexbox;
  flex-direction: row;
}
@media (max-width: 1024px) {
  .benefits {
    flex-direction: column;
  }
}
.benefits .benefitstext {
  padding-top: 20px;
  float: left;
  max-width: 701px;
  margin-left: 0%;
}
.benefits .benefitstext .ul,
.benefits li {
  list-style-type: disc;
  list-style-position: outside;
  font-size: 16px;
  line-height: 28px;
  margin-left: 14px;
}
@media (max-width: 1024px) {
  .benefits .benefitstext .ul,
  .benefits li {
    font-size: 16px;
    line-height: 20px;
  }
}
.benefits .benefitsimage {
  float: right;
  height: 390px;
  width: 390px;
}
@media (max-width: 1024px) {
  .benefits .benefitsimage {
    height: 243px;
    width: 343px;
  }
}
.benefits .benefitsimage .benefitsimagespec {
  width: 100%;
  height: 100%;
}

.subscriptionsection {
  padding-top: 10px;
  position: static;
}
@media (max-width: 1024px) {
  .subscriptionsection {
    padding-top: 50%;
  }
}
.subscriptionsection .subscriptioncontent {
  max-width: 100%;
  padding-top: 50px;
  background-color: #F2F2F2;
  opacity: 1;
}
.subscriptionsection .subscriptioncontent .tabheading {
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 42.5px;
  font-size: 28px;
  letter-spacing: 0.81px;
  color: #000000;
  opacity: 100%;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .tabheading {
    font-size: 28px;
  }
}
.subscriptionsection .subscriptioncontent .subheading {
  font-size: 16px;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-right: 1%;
  margin-left: 1%;
}
.subscriptionsection .subscriptioncontent .subscription-images {
  margin: 0 15% 2% 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0px 20px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .card-flex {
  width: 102%;
  margin-left: 20px;
  margin-right: auto;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card {
  border: 1px solid #FFFFFF;
  height: 100%;
  background: #FFFFFF;
  margin: 0 5% 0 5%;
  text-align: center;
  padding: 35px 15px 35px 15px;
  width: 102%;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card h2 {
  font-size: 29px;
  margin-bottom: 5px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card p {
  font-size: 14px;
  margin: 0 20px;
  text-align: center;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .starting-text {
  text-align: center;
  font-size: 18px;
  padding-top: 15px;
  padding-bottom: 30px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .starting-text1 {
  text-align: center;
  font-size: 18px;
  padding-top: 0px;
  padding-bottom: 30px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .starting-text-second {
  text-align: center;
  font-size: 18px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .bold-price {
  text-align: center;
  font-size: 48px;
  font-weight: 900;
  padding-bottom: 20px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .bold-pricing {
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 1.07px;
  line-height: 30px;
  margin: 0 20px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .devices-no {
  text-align: center;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 50px;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .plan-list {
  font-size: 19px;
  width: 60%;
  text-align: center;
  padding-bottom: 40px;
  margin: 0 20%;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .plan-lists-div {
  padding: 35px 0 0 0;
}
.subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .plan-lists {
  font-size: 18px;
  margin: 0 20px;
  text-align: justify;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subscription-images {
    flex-direction: column;
    margin: 0 5% 2% 5%;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards {
    width: 100%;
    margin: 15px 0 15px 0;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .card-flex {
    width: 102%;
    margin-left: auto;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card {
    margin: 0;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card h2 {
    font-size: 22px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card p {
    font-size: 16px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .starting-text, .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .starting-text-second {
    font-size: 14px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .bold-price {
    font-size: 44px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .devices-no {
    font-size: 18px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .plan-list {
    font-size: 13px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .bold-pricing {
    font-size: 28px;
  }
  .subscriptionsection .subscriptioncontent .subscription-images .subscription-cards .subscription-card .plan-lists {
    font-size: 16px;
    margin: 0px;
  }
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images {
  margin-left: 90px;
  margin-top: 10px;
  display: flex;
  flex-flow: row wrap;
  position: relative;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards {
  text-align: left;
  float: left;
  margin: 10px 60px 10px 40px;
  flex: 0 1 calc(20% - 8px);
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .card-flex {
  width: 100%;
  margin-right: auto;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card {
  border: 1px solid #FFFFFF;
  height: 100%;
  background: #FFFFFF;
  width: 250px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card h2 {
  margin-top: 10px;
  font-size: 28px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: bold;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .subscription-sub-content {
  font-size: 14px;
  height: 70px;
  margin: 10px 10px 10px 10px;
  text-align: center;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .subscription-descheading {
  text-align: start;
  font-size: 18px;
  margin-top: 10px;
  margin-left: 10px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .subscription-desc-content {
  text-align: start;
  margin-top: 10px;
  margin-left: 10px;
  font-size: 14px;
  height: 140px;
  line-height: 24px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .subscription-goodheading {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-left: 10px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .keyfeatures {
  margin-top: 10px;
  margin-left: 12px;
  font-size: 14px;
  height: 120px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .keyfeatures ul, .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .keyfeatures li {
  margin-left: 2px;
  list-style: disc outside none;
  font-size: 14px;
  line-height: 24px;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .keyfeatures {
    font-size: 12px;
    line-height: 20px;
  }
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .request-solution {
  margin-left: 40px;
  margin-top: 30px;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .request-solution {
    margin-left: 24%;
    margin-top: 30px;
  }
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .bold-price {
  text-align: start;
  margin-top: 10px;
  margin-left: 10px;
  font-size: 14px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .devices-no {
  text-align: center;
  font-size: 18px;
  font-weight: 900;
  margin-top: 30px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .sub-notes {
  padding-top: 40px;
  text-align: center;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .note-heading {
  font-weight: bold;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .plan-list {
  font-size: 19px;
  width: 60%;
  text-align: center;
  margin-top: 40px;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .plan-lists-div {
  padding: 35px 0 0 0;
}
.subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .plan-lists {
  font-size: 18px;
  margin: 0 20px;
  text-align: justify;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images {
    flex-direction: column;
    margin: 0 5% 2% 5%;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards {
    width: 100%;
    margin: 15px 0 15px 0;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .card-flex {
    width: 100%;
    margin-left: auto;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card {
    margin: 0;
    width: 100%;
    padding: 7px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card h2 {
    font-size: 22px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card p {
    font-size: 16px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .starting-text, .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .starting-text-second {
    font-size: 14px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .bold-price {
    font-size: 44px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .devices-no {
    font-size: 18px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .plan-list {
    font-size: 13px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .bold-pricing {
    font-size: 28px;
  }
  .subscriptionsection .subscriptioncontent .subscription-fiveg-images .subscription-fiveg-cards .subscription-fiveg-card .plan-lists {
    font-size: 16px;
    margin: 0px;
  }
}
.subscriptionsection .subscriptioncontent .subimages {
  margin-left: 20%;
  margin-right: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding-bottom: 10px;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subimages {
    flex-direction: column;
  }
}
.subscriptionsection .subscriptioncontent .subimage {
  margin-left: 10px;
  margin-right: 10px;
  height: 440px;
  width: 390px;
}
@media (max-width: 1024px) {
  .subscriptionsection .subscriptioncontent .subimage {
    height: 300px;
    width: 300px;
    padding-bottom: 10px;
  }
}
.subscriptionsection .subscriptioncontent .subeligiblebox {
  background: #106FBA 0% 0% no-repeat padding-box;
  margin-top: 15px;
}
.subscriptionsection .subscriptioncontent .subeligibletext {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: 10%;
  margin-right: 10%;
  max-width: 70%;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  opacity: 100%;
}

.detailsection {
  padding-top: 15px;
  max-width: 100%;
  padding-bottom: 10px;
  display: flexbox;
  flex-direction: row;
  margin-left: 100px !important;
}
@media (max-width: 1024px) {
  .detailsection {
    flex-direction: column;
    margin-left: 0px !important;
  }
}
.detailsection .detailsheader {
  max-width: 30%;
  margin-left: 5%;
  font-size: 30px;
  line-height: 40px;
  float: left;
  letter-spacing: 0.81px;
  color: #000000;
  opacity: 1;
  margin: -5px;
}
@media (max-width: 1024px) {
  .detailsection .detailsheader {
    font-size: 28px;
    margin-left: 20px;
    float: none;
  }
}
@media only screen and (max-width: 768px) {
  .detailsection .detailsheader {
    font-size: 24px;
    margin-left: 20px;
    float: none;
  }
}

.outerboxwithsmallfont {
  margin-left: 25%;
  margin-right: 2%;
  padding-bottom: 10px;
  font-size: 14px;
}
@media (max-width: 1024px) {
  .outerboxwithsmallfont {
    padding-top: 10px;
    margin-left: 5%;
    margin-right: 5%;
  }
}

.outerbox {
  margin-left: 25%;
  margin-right: 2%;
  padding-bottom: 20px;
}
@media (max-width: 1024px) {
  .outerbox {
    padding-top: 10px;
    margin-left: 5%;
    margin-right: 5%;
  }
}

.outerbox ul, .outerbox li {
  list-style: disc outside none;
  font-size: 16px;
  line-height: 28px;
  margin-left: 8px;
}
@media screen and (max-width: 1024px) {
  .outerbox ul, .outerbox li {
    font-size: 16px;
  }
}
@media (max-width: 1024px) {
  .outerbox {
    font-size: 16px;
    line-height: 20px;
  }
}
@media only screen and (max-width: 768px) {
  .outerbox {
    font-size: 14px;
  }
}

.plan-fiveg-note {
  text-align: center;
  font-style: italic;
}

@media screen and (max-width: 1024px) {
  .overview {
    margin-left: 10px !important;
  }
}

.smallbox {
  float: left;
  margin-left: 0%;
  margin-right: 15px;
  padding-bottom: 55px;
}
@media (max-width: 1024px) {
  .smallbox {
    margin-left: 15%;
  }
}
.smallbox .line {
  border: 3px solid #52B6EB;
  background-color: #52B6EB;
  opacity: 1;
  width: 183px;
}
@media (max-width: 1024px) {
  .smallbox .line {
    width: 183px;
  }
}
.smallbox .smalltext {
  padding-top: 7px;
  padding-bottom: 20px;
  text-align: left;
  width: 183px;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .smallbox .smalltext {
    width: 183px;
    font-size: 16px;
  }
}

.largebox {
  float: left;
  margin-left: 0%;
  margin-right: 5%;
  width: 350px;
}
@media (max-width: 1024px) {
  .largebox {
    width: 335px;
  }
}
.largebox .line {
  border: 3px solid #52B6EB;
  background-color: #52B6EB;
  opacity: 1;
  width: 380px;
}
@media (max-width: 1024px) {
  .largebox .line {
    width: 320px;
  }
}
@media screen and (max-width: 1024px) {
  .largebox .line {
    width: 100%;
  }
}
.largebox .largetext {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 5px;
  text-align: left;
  width: 380px;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .largebox .largetext {
    font-size: 16px;
  }
}
@media screen and (max-width: 768px) {
  .largebox .largetext {
    font-size: 16px;
    width: 100%;
  }
}

.rightbox {
  margin-top: -20px;
}
@media (max-width: 1024px) {
  .rightbox {
    margin-top: 0px;
  }
}

.appleReq {
  margin-left: 100px !important;
}
@media (max-width: 1024px) {
  .appleReq {
    margin-left: 0px !important;
  }
}

.requirementsection {
  padding-top: 15px;
  max-width: 100%;
  padding-bottom: 15px;
  display: flexbox;
  flex-direction: row;
}
@media (max-width: 1024px) {
  .requirementsection {
    flex-direction: column;
    margin-left: 0px !important;
  }
}
.requirementsection .requirementsheader {
  max-width: 20%;
  margin-left: 5%;
  font-size: 30px;
  line-height: 40px;
  float: left;
  letter-spacing: 0.81px;
  color: #000000;
  opacity: 1;
  margin: -5px;
}
@media (max-width: 1024px) {
  .requirementsection .requirementsheader {
    font-size: 28px;
    max-width: 70%;
    margin-left: 20px;
    float: none;
  }
}
@media only screen and (max-width: 768px) {
  .requirementsection .requirementsheader {
    font-size: 24px;
  }
}

.usecases-section {
  padding-top: 15px;
  max-width: 100%;
  padding-bottom: 10px;
  padding-left: 9%;
}

.usecasesHeading {
  font-size: 28px;
  line-height: 40px;
  float: left;
  letter-spacing: 0.81px;
  font-weight: bold;
  padding-left: 0%;
}

.usecasesDesc {
  margin-top: 50px;
}

.mat-expansion-indicator {
  margin-right: 67px;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #1D83D9;
  width: 20px;
}

.mat-expansion-panel-header :focus,
.mat-expansion-panel-header :focus-within,
.mat-expansion-panel-header:focus-visible {
  background-color: lightgrey !important;
}

.usecasesDetails {
  margin-left: 100px;
  margin-top: 10px;
  margin-bottom: 30px;
  display: flex;
  flex-flow: row wrap;
  position: relative;
  align-items: baseline;
  height: 100% !important;
  padding: 0 !important;
}
@media (max-width: 1024px) {
  .usecasesDetails {
    margin-left: 10px !important;
  }
}

.usecase-cards {
  border: 1px solid #000000;
  margin-left: 80px;
  margin-top: 30px;
  width: 230px;
}

.image-icon {
  margin-top: 10px;
  margin-left: 90px;
}

.usecase-subheading {
  font-size: 18px;
  margin-top: 20px;
  margin-left: 10px;
  text-align: center;
}

.usecase {
  margin-left: 14px;
  height: 149px;
  margin-top: 10px;
  font-size: 14px;
}
.usecase ul, .usecase li {
  list-style: disc outside none;
  font-size: 14px;
  line-height: 24px;
}

.EasyDeployHeader {
  max-width: 25%;
  margin-left: 5%;
  font-size: 28px;
  line-height: 40px;
  float: left;
  letter-spacing: 0.81px;
  color: #000000;
  opacity: 1;
  margin: -5px;
  display: flex;
}
@media (max-width: 1024px) {
  .EasyDeployHeader {
    font-size: 20px;
    max-width: 70%;
    margin-left: 20px;
    float: none;
  }
}

.easyDeployNote {
  margin-top: 10px;
  margin-bottom: 25px;
  float: right;
  font-size: 14px;
}
@media screen and (max-width: 1024px) {
  .easyDeployNote {
    margin-left: 21px !important;
  }
}

.alert {
  margin: 20px;
  border-radius: 8px;
}

.alert div:first-child {
  border-radius: 8px 0 0 8px;
}

.submitting {
  height: 50px;
  margin-left: 45%;
  width: 50px;
}

.success-msg {
  color: #007a3d;
  margin: 5px;
  font: 24px/25px "Omnes-ATT-W02-Light";
}

.buttons-section {
  height: 115px;
  margin-bottom: 100px;
  max-width: 681px;
}

.mar-top-20 {
  margin-top: 50px;
  margin-left: 60px !important;
}

@media only screen and (max-width: 768px) {
  .mar-top-20 {
    margin-top: 60px;
    margin-left: 4px;
    margin-right: -4px;
  }
}
.banner-section {
  align-items: center;
  height: 500px;
  overflow: hidden;
  position: relative;
  width: 99.4vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
.banner-section .banner-caption {
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  padding-left: 10px;
  position: absolute;
  top: 50%;
  width: 100%;
}
.banner-section .banner-caption #bannerNameSection {
  color: white;
  margin-bottom: 5px;
  margin-top: 5px;
  line-height: 40px;
  letter-spacing: 1.11px;
  text-align: left;
  max-width: 70%;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption #bannerNameSection {
    font-size: 28px;
    line-height: 28px;
    letter-spacing: 0.47px;
    margin-top: 57px;
    max-width: 70%;
    margin-bottom: 17px;
  }
}
@media only screen and (max-width: 768px) {
  .banner-section .banner-caption #bannerNameSection {
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.47px;
    margin-top: 20px;
    max-width: 70%;
  }
}
.banner-section .banner-caption #proDesc {
  color: #52B6EB;
}
.banner-section .banner-caption #whiteBannerName {
  color: white;
  margin-bottom: 5px;
  margin-top: 5px;
  line-height: 40px;
  letter-spacing: 1.11px;
  opacity: 1;
  text-align: left;
  max-width: 90%;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption #whiteBannerName {
    font-size: 28px;
    line-height: 22px;
    letter-spacing: 0.47px;
    max-width: 70%;
    margin-top: 45px;
  }
}
@media (max-width: 1024px) {
  .banner-section .banner-caption #lightBannerNameSection {
    font-size: 28px;
  }
}
@media only screen and (max-width: 768px) {
  .banner-section .banner-caption #lightBannerNameSection {
    font-size: 18px;
  }
}
.banner-section .banner-caption .lightBannerNameSection {
  color: #000000;
  margin-bottom: 5px;
  margin-top: 5px;
  line-height: 40px;
  letter-spacing: 1.11px;
  opacity: 1;
  text-align: left;
  max-width: 70%;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption .lightBannerNameSection {
    font-size: 17px;
    line-height: 19px;
    letter-spacing: 0.47px;
    max-width: 70%;
    margin-top: 20px;
  }
}
.banner-section .banner-caption .product-text {
  margin-left: -15px;
  margin-right: -15px;
  width: 100%;
  max-width: 480px;
  color: white;
  font-size: 18px;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption .product-text {
    margin-left: -15px;
    margin-right: -15px;
    font-size: 18px;
    width: 100%;
    line-height: 18px;
  }
}
@media only screen and (max-width: 768px) {
  .banner-section .banner-caption .product-text {
    margin-left: -15px;
    margin-right: -15px;
    font-size: 12px;
    width: 100%;
    line-height: 12px;
  }
}
@media (max-width: 1024px) {
  .banner-section .banner-caption .checkboxText {
    font-size: 10px;
    margin-right: 151px;
  }
}
.banner-section .banner-caption .white-product-text {
  margin-left: -15px;
  margin-right: -15px;
  width: 100%;
  max-width: 480px;
  text-align: left;
  letter-spacing: 0.48px;
  color: white;
  opacity: 1;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption .white-product-text {
    margin-left: -15px;
    margin-right: -15px;
    font-size: 10px;
    width: 70%;
    line-height: 12px;
  }
}
.banner-section .banner-caption .light-product-text {
  margin-left: -15px;
  margin-right: -15px;
  width: 100%;
  max-width: 480px;
  text-align: left;
  letter-spacing: 0.48px;
  color: #000000;
  opacity: 1;
  font-size: 18px;
}
@media (max-width: 1024px) {
  .banner-section .banner-caption .light-product-text {
    margin-left: -15px;
    margin-right: -15px;
    font-size: 18px;
    width: 100%;
    line-height: 18px;
  }
}
@media only screen and (max-width: 768px) {
  .banner-section .banner-caption .light-product-text {
    font-size: 12px;
  }
}
.banner-section img {
  left: 50%;
  max-width: 1920px;
  position: absolute;
  transform: translateX(-50%);
}
@media only screen and (max-width: 1024px) {
  .banner-section img {
    transform: translateX(0%) !important;
    left: 0% !important;
    max-width: 1024px !important;
    position: absolute;
    top: 0px !important;
  }
}

.hide-small {
  display: block;
  visibility: visible !important;
}

.show-small {
  display: none;
  visibility: hidden;
}

.productImage {
  opacity: unset !important;
}

@media (max-width: 767px) {
  .hide-small {
    display: none;
    visibility: hidden;
  }
  .show-small {
    display: block;
    visibility: visible !important;
  }
}
@media (max-width: 1024px) {
  .details-page {
    padding-bottom: 10px;
  }
  .banner-section {
    align-items: center;
    height: auto;
    overflow: hidden;
    position: relative;
    margin-top: 50px;
  }
  .banner-section figure {
    height: 250px;
    overflow: hidden;
    position: relative;
    margin-inline-end: 0px;
    margin-bottom: -50px;
  }
  .banner-section img {
    left: 50%;
    width: auto;
    max-width: 1024px;
    position: absolute;
    transform: translateX(-50%);
  }
  .banner-section .banner-caption {
    left: 0;
    padding-left: 0;
    top: 40%;
  }
  .banner-section .banner-caption h1 {
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .banner-section .banner-caption p {
    margin-bottom: 10px;
  }
  .banner-section .banner-caption .firstnetErrorMessageLink {
    color: #0000EE;
    text-decoration: none;
    outline: none;
  }
  .banner-section .banner-caption .btn-secondary {
    font-size: 12px;
  }
  .banner-section .banner-caption h2.product-style {
    margin-bottom: 10px !important;
  }
}
.program a {
  color: #191919 !important;
}

#banner-section-light figure {
  height: 600px;
  width: 100vw;
  background: black;
  overflow: hidden;
}

#banner-section-light img {
  object-fit: cover;
  opacity: 0.5;
}

@media (max-width: 1024px) {
  #banner-section-light figure {
    height: 237px;
    width: 100vw;
    background: black;
    overflow: hidden;
  }
  #banner-section-light img {
    object-fit: none;
    opacity: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/learn-details/learndetails.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAmJF;;AA7IA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAgJF;;AA9IA;EACE,6BAAA;AAiJF;;AA/IA;EACE,6BAAA;AAkJF;;AAhJA;EACI,iBAAA;AAmJJ;;AAhJA;EACE,iBAAA;AAmJF;;AAhJA;EACE,kBAAA;AAmJF;;AAhJA;EACE,6BAAA;EACA,kBAAA;AAmJF;;AAhJA;EACA;IACE,iBAAA;EAmJA;AACF;AFtKI;EEyBF;IACE,6BAAA;EAgJF;EA9IA;IACE,2BAAA;EAgJF;EA9IA;IACE,4BAAA;EAgJF;EA9IA;IACI,gBAAA;EAgJJ;EA9ID;IACK,gBAAA;EAgJJ;EA9IF;IACE,gBAAA;EAgJA;EA9IA;IACE,qBAAA;EAgJF;AACF;AA3IA;EACE,WAAA;EACA,gBAAA;AA6IF;;AA1IA;EACE,yLAAA;EACA,oDAAA;EACA,kCAAA;EACA,gBAAA;EACA,wDAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AA6IF;;AA1IA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AA6IF;;AA1IA;EACE,eAAA;AA6IF;AA5IE;EAFF;IAGI,eAAA;IACA,iBAAA;EA+IF;AACF;;AA3IA;EACE,YAAA;EACA,gBAAA;AA8IF;;AA3IA;EACE,aAAA;EACA,iBAAA;AA8IF;;AA3IA;EACE,cAAA;AA8IF;AA5IE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AA8IJ;;AA1IA;EAEE,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA2IF;;AAxIA;EACE,iCAAA;AA2IF;AFhQI;EEoHJ;IAKI,iCAAA;EA2IF;AACF;AAzIE;EARF;IASI,iCAAA;EA4IF;AACF;;AAvIA;EACE,eAAA;AA0IF;;AAvIA;EACE,mBAAA;EACA,mEAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AA0IF;;AArIA;EACE,iCAAA;AAwIF;;AAjIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AAoIF;AFzSI;EE8JJ;IAUI,eAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;EAqIF;AACF;;AAlIA;EACE,gBAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAqIF;AAlIE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAoIJ;AFnUI;EE2LF;IAOI,yBAAA;IACD,2BAAA;IACA,gBAAA;EAqIH;AACF;AAjIE;EACE,kBAAA;EACA,iBAAA;AAmIJ;AF9UI;EEyMF;IAKI,eAAA;IACA,kBAAA;EAoIJ;AACF;AAhII;EAXF;IAYI,eAAA;IACA,iBAAA;EAmIJ;AACF;AA/HE;EACE,eAAA;AAiIJ;AA9HE;EACE,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAgIJ;AFzWI;EE+NF;IAaI,UAAA;IACA,WAAA;IACA,kBAAA;EAiIJ;AACF;;AA7HA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAgIF;AFtXI;EEmPJ;IAMI,iBAAA;IACA,eAAA;IACA,iBAAA;EAiIF;AACF;AAhIE;EAVF;IAWI,eAAA;EAmIF;AACF;;AFlYI;EEmQJ;IACE,4BAAA;IACA,2BAAA;EAmIA;AACF;AAhIA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAkIF;AF/YI;EEyQJ;IAMI,iBAAA;IACA,gBAAA;EAoIF;AACF;;AAjIA;EACE,+BAAA;AAoIF;;AAjIA;EACE,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAoIF;AFjaI;EEwRJ;IAQI,eAAA;IACA,iBAAA;EAqIF;AACF;AAnIE;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AAqIJ;AF5aI;EEoSF;IAMI,eAAA;IACA,eAAA;EAsIJ;AACF;AArII;EATF;IAUI,eAAA;EAwIJ;AACF;;AApIA;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAuIF;AF/bI;EEmTJ;IAQI,sBAAA;EAwIF;AACF;AAtIE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAwIJ;AArIE;;EAEE,qBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAuIJ;AFldI;EEqUF;;IASI,eAAA;IACA,iBAAA;EAyIJ;AACF;AAtIE;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAwIJ;AF9dI;EEmVF;IAMI,aAAA;IACA,YAAA;EAyIJ;AACF;AAvII;EACE,WAAA;EACA,YAAA;AAyIN;;AApIA;EACE,iBAAA;EACA,gBAAA;AAuIF;AF7eI;EEoWJ;IAKI,gBAAA;EAwIF;AACF;AAtIE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;AAwIJ;AArII;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAuIN;AFngBI;EEmXA;IAYI,eAAA;EAwIN;AACF;AArII;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAuIN;AApII;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsIN;AApIM;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAsIP;AApIO;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AAsIT;AAnIM;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;AAqIR;AAlIQ;EACE,eAAA;EACA,kBAAA;AAoIV;AAjIQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAmIV;AAhIQ;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAkIV;AA/HQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAiIV;AA9HQ;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAgIV;AA7HQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA+HV;AA5HQ;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AA8HV;AA3HQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA6HV;AA1HQ;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;AA4HV;AAzHQ;EACE,mBAAA;AA2HV;AAxHQ;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA0HV;AFvmBI;EEsfE;IACE,sBAAA;IACA,kBAAA;EAoHN;EAnHK;IACE,WAAA;IACA,qBAAA;EAqHP;EAnHO;IACE,WAAA;IACA,iBAAA;EAqHT;EAnHM;IACE,SAAA;EAqHR;EAnHS;IACE,eAAA;EAqHX;EAlHS;IACE,eAAA;EAoHX;EAjHS;IACE,eAAA;EAmHX;EAhHS;IACE,eAAA;EAkHX;EA/GS;IACE,eAAA;EAiHX;EA9GS;IACE,eAAA;EAgHX;EA7GS;IACE,eAAA;EA+GX;EA5GS;IACE,eAAA;IACA,WAAA;EA8GX;AACF;AAxGI;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA0GN;AAxGM;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,yBAAA;AA0GN;AAxGO;EACE,WAAA;EACA,kBAAA;AA0GT;AAvGM;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAyGR;AAvGQ;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAyGV;AAvGQ;EACE,eAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;AAyGV;AAtGQ;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAwGV;AArGQ;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AAuGV;AApGQ;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAsGV;AAnGQ;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AAqGV;AAnGU;EACE,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAqGZ;AFrtBI;EEsmBI;IAcM,eAAA;IACA,iBAAA;EAqGZ;AACF;AAlGQ;EACE,iBAAA;EACA,gBAAA;AAoGV;AF/tBI;EE+nBI;IACE,gBAAA;IACA,gBAAA;EAmGR;AACF;AAhGQ;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAkGV;AA/FQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAiGV;AA9FQ;EACE,iBAAA;EACA,kBAAA;AAgGV;AA7FQ;EACE,iBAAA;AA+FV;AA5FQ;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AA8FV;AA3FQ;EACE,mBAAA;AA6FV;AA1FQ;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA4FV;AFtwBI;EEmrBE;IACE,sBAAA;IACA,kBAAA;EAsFN;EArFK;IACE,WAAA;IACA,qBAAA;EAuFP;EArFO;IACE,WAAA;IACA,iBAAA;EAuFT;EArFM;IACE,SAAA;IACA,WAAA;IACA,YAAA;EAuFR;EAtFS;IACE,eAAA;EAwFX;EArFS;IACE,eAAA;EAuFX;EApFS;IACE,eAAA;EAsFX;EAnFS;IACE,eAAA;EAqFX;EAlFS;IACE,eAAA;EAoFX;EAjFS;IACE,eAAA;EAmFX;EAhFS;IACE,eAAA;EAkFX;EA3ES;IACE,eAAA;IACA,WAAA;EA6EX;AACF;AAvEI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAyEN;AF3zBI;EE2uBA;IAUI,sBAAA;EA0EN;AACF;AAvEI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAyEN;AFt0BI;EEyvBA;IAOI,aAAA;IACA,YAAA;IACA,oBAAA;EA0EN;AACF;AAvEI;EACE,+CAAA;EACA,gBAAA;AAyEN;AAtEI;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AAwEN;;AAnEA;EACE,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAsEF;AFr2BI;EEyxBJ;IASI,sBAAA;IACA,2BAAA;EAuEF;AACF;AApEE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AAsEJ;AFt3BI;EEuyBF;IAYI,eAAA;IACA,iBAAA;IACA,WAAA;EAuEJ;AACF;AAtEI;EAhBF;IAiBI,eAAA;IACA,iBAAA;IACA,WAAA;EAyEJ;AACF;;AArEA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAwEF;AF34BI;EE+zBJ;IAOI,iBAAA;IACA,eAAA;IACA,gBAAA;EAyEF;AACF;;AAtEA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;AAyEF;AFx5BI;EE40BJ;IAMI,iBAAA;IACA,eAAA;IACA,gBAAA;EA0EF;AACF;;AAtEE;EACE,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAyEJ;AAvEI;EANF;IAOI,eAAA;EA0EJ;AACF;AF36BI;EEw1BJ;IAaM,eAAA;IACA,iBAAA;EA0EJ;AACF;AAxEM;EAjBN;IAkBQ,eAAA;EA2EN;AACF;;AAvEA;EACE,kBAAA;EACA,kBAAA;AA0EF;;AAtEE;EADF;IAEE,4BAAA;EA0EA;AACF;;AAvEA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;AA0EF;AFx8BI;EE03BJ;IAOI,gBAAA;EA2EF;AACF;AAzEE;EACE,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;AA2EJ;AFn9BI;EEo4BF;IAOI,YAAA;EA4EJ;AACF;AAzEE;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA2EJ;AF/9BI;EE+4BF;IAQI,YAAA;IACA,eAAA;EA4EJ;AACF;;AAxEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA2EF;AF5+BI;EE65BJ;IAQI,YAAA;EA2EF;AACF;AAzEE;EACE,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;AA2EJ;AFv/BI;EEw6BF;IAOI,YAAA;EA4EJ;AACF;AA3EI;EATF;IAUI,WAAA;EA8EJ;AACF;AA3EE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA6EJ;AFzgCI;EEs7BF;IASI,eAAA;EA8EJ;AACF;AA5EI;EAZF;IAaI,eAAA;IACA,WAAA;EA+EJ;AACF;;AA3EA;EACE,iBAAA;AA8EF;AFxhCI;EEy8BJ;IAGI,eAAA;EAgFF;AACF;;AA9EA;EACE,6BAAA;AAiFF;AFjiCI;EE+8BJ;IAGI,2BAAA;EAmFF;AACF;;AA/EA;EACE,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAkFF;AF9iCI;EEu9BJ;IAQI,sBAAA;IACA,2BAAA;EAmFF;AACF;AAjFE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;AAmFJ;AF/jCI;EEm+BF;IAYI,eAAA;IACA,cAAA;IACA,iBAAA;IACA,WAAA;EAoFJ;AACF;AAlFI;EAlBF;IAmBI,eAAA;EAqFJ;AACF;;AAjFE;EACC,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAoFH;;AAlFI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAqFN;;AAnFI;EACE,gBAAA;AAsFN;;AApFI;EACE,kBAAA;EACD,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAuFL;;AArFI;;;EAGE,sCAAA;AAwFN;;AArFI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AAwFN;AF1nCI;EEyhCA;IAWI,4BAAA;EA0FN;AACF;;AAxFI;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AA2FN;;AAzFI;EACE,gBAAA;EACA,iBAAA;AA4FN;;AAzFI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA4FN;;AA1FI;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AA6FN;AA5FM;EACE,6BAAA;EACA,eAAA;EACD,iBAAA;AA8FP;;AAxFA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AA2FF;AF3qCI;EEskCJ;IAcI,eAAA;IACA,cAAA;IACA,iBAAA;IACA,WAAA;EA2FF;AACF;;AAxFA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA2FF;AAxFE;EAPF;IAQI,4BAAA;EA2FF;AACF;;AAxFA;EACE,YAAA;EACA,kBAAA;AA2FF;;AAxFA;EACE,0BAAA;AA2FF;;AAxFA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AA2FF;;AAxFA;EACE,cAAA;EACA,WAAA;EACA,qCAAA;AA2FF;;AAxFA;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AA2FF;;AAvFA;EACE,gBAAA;EACA,4BAAA;AA0FF;;AAvFA;EACE;IACE,gBAAA;IACA,gBAAA;IACA,kBAAA;EA0FF;AACF;AAxFA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AA0FF;AAxFE;EF9oCE,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EEgpCA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AA8FJ;AA5FI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AA8FN;AFvwCI;EEkqCA;IAUI,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,gBAAA;IACA,cAAA;IACA,mBAAA;EA+FN;AACF;AA9FM;EAjBF;IAkBI,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,gBAAA;IACA,cAAA;EAiGN;AACF;AA9FI;EACI,cAAA;AAgGR;AA7FI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AA+FN;AFvyCI;EEgsCA;IAWI,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,gBAAA;EAgGN;AACF;AFhzCI;EEmtCA;IAEI,eAAA;EA+FN;AACF;AA9FM;EAJF;IAKI,eAAA;EAiGN;AACF;AA9FI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AAgGN;AFp0CI;EE4tCA;IAWI,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;IACA,gBAAA;EAiGN;AACF;AA9FI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAgGN;AFr1CI;EE+uCA;IASI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,iBAAA;EAiGN;AACF;AAhGM;EAfF;IAgBI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,iBAAA;EAmGN;AACF;AFv2CI;EEuwCA;IAEI,eAAA;IACA,mBAAA;EAkGN;AACF;AA/FI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AAiGN;AFv3CI;EE8wCA;IAUI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,UAAA;IACA,iBAAA;EAmGN;AACF;AAhGI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AAkGN;AF34CI;EEgyCA;IAYI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,iBAAA;EAmGN;AACF;AAjGM;EAnBF;IAoBI,eAAA;EAoGN;AACF;AAhGE;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EAEA,2BAAA;AAiGJ;AA/FI;EAPF;IAQI,oCAAA;IACA,mBAAA;IACA,4BAAA;IACA,kBAAA;IACA,mBAAA;EAkGJ;AACF;;AA7FA;EACE,cAAA;EACA,8BAAA;AAgGF;;AA7FA;EACE,aAAA;EACA,kBAAA;AAgGF;;AA7FA;EACE,yBAAA;AAgGF;;AA7FA;EAEE;IACE,aAAA;IACA,kBAAA;EA+FF;EA5FA;IACE,cAAA;IACA,8BAAA;EA8FF;AACF;AFj8CI;EEu2CF;IACE,oBAAA;EA6FF;EA1FA;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EA4FF;EA1FE;IACE,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,sBAAA;IACA,oBAAA;EA4FJ;EAzFE;IACE,SAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,2BAAA;EA2FJ;EAxFE;IACE,OAAA;IACA,eAAA;IACA,QAAA;EA0FJ;EAxFI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EA0FN;EAvFI;IACE,mBAAA;EAyFN;EAtFI;IACE,cAAA;IACA,qBAAA;IACA,aAAA;EAwFN;EA3EI;IACE,eAAA;EA6EN;EA1EI;IACE,8BAAA;EA4EN;AACF;AArEA;EACE,yBAAA;AAuEF;;AApEA;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAuEJ;;AApEA;EACE,iBAAA;EACC,YAAA;AAuEH;;AFngDI;EEg8CF;IACE,aAAA;IACA,YAAA;IACA,iBAAA;IACA,gBAAA;EAuEF;EApEF;IACE,gBAAA;IACC,cAAA;EAsED;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.flex-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n.container-box, main, .main-wrapper{\n  // padding-left: 10px !important;\n  // padding-right: 0px !important;\n  }\n.flex-item {\n  padding: 5px;\n  width: 600px;\n  min-width: 320px;\n}\n.heading{\n  padding-left: 95px !important;\n}\n.shortdec{\n  margin-left: 100px !important;\n  }\n.moveleft {\n    margin-left: 82px;\n}\n\n.bannerHeader {\n  margin-left: 90px;\n}\n\n.benefitContent {\n  margin-left: 100px;\n}\n\n.tabrow {\n  margin-left: 100px !important;\n  position: relative;\n}\n\n@media only screen and (max-width: 768px){\n.bannerNameSectionSmall{\n  margin-left: 21px;\n}  }\n@include respond-to (small) {\n  main, .main-wrapper {\n    // padding-left: 0px !important;\n    // padding-right: 0px !important;\n}\n  .heading{\n    padding-left: 25px !important;\n  }\n  .tabrow {\n    margin-left: 0px !important;\n  }\n  .shortdec{\n    margin-left: -1px !important;\n  }\n  .moveleft {\n      margin-left: 0px;\n  }\n .bannerHeader {\n      margin-left: 0px;\n  }\n.benefitContent {\n  margin-left: 0px;\n} \n  .helper-text {\n    left: 15px !important;\n  }\n}\n\n\n\n.success-icon {\n  float: left;\n  padding-top: 5px;\n}\n\n.programs-heading {\n  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-medium) var(--unnamed-font-size-18)/var(--unnamed-line-spacing-21) var(--unnamed-font-family-attalecksans-medium);\n  letter-spacing: var(--unnamed-character-spacing-0-6);\n  color: var(--unnamed-color-000000);\n  text-align: left;\n  font: normal normal medium 18px/21px ATTAleckSans-Medium;\n  letter-spacing: 0.6px;\n  color: #000000;\n  opacity: 1;\n}\n\n.programs {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.programs-note {\n  font-size: 14px;\n  @media only screen and (max-width: 768px){\n    font-size:12px;\n    margin-left: 10px;\n}\n\n}\n\n.program {\n  margin: 12px;\n  max-width: 340px;\n}\n\n.program-img {\n  height: 169px;\n  object-fit: cover;\n}\n\n.programsEfotaImage {\n  flex: 0 0 auto;\n\n  img {\n    height: 258px;\n    object-fit: cover;\n    object-position: right;\n    width: 596px;\n  }\n}\n\n.programsEfotaText {\n\n  flex: 0 1 auto;\n\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  padding: 0 0 0 15px;\n  max-width: 596px;\n}\n\n.program-title {\n  font: 30px 'Omnes-ATT-W02-Medium';\n\n\n  @include respond-to(small) {\n    font: 28px 'Omnes-ATT-W02-Medium';\n  }\n\n  @media only screen and (max-width: 768px){\n    font: 24px 'Omnes-ATT-W02-Medium';\n  }\n\n\n}\n\n.program-details {\n  font-size: 16px;\n}\n\n.programs-efota {\n  align-items: center;\n  background: var(--unnamed-color-f2f2f2) 0% 0% no-repeat padding-box;\n  background: #F2F2F2 0% 0% no-repeat padding-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-bottom: 0;\n  padding: 46px 0 46px 0;\n  width: 100%;\n\n}\n\n\n.programsEfotaTextTitle {\n  font: 28px 'Omnes-ATT-W02-Medium';\n}\n\n#StartedHeader {\n  // top: 348px;\n}\n\n.gettingStartedHeader {\n  max-width: 217px;\n  font-size: 30px;\n  line-height: 40px;\n  float: left;\n  letter-spacing: 0.81px;\n  color: #000000;\n  opacity: 1;\n\n  @include respond-to(small) {\n    font-size: 20px;\n    max-width: 100%;\n    margin-left: 10px;\n    line-height: 30px;\n  }\n}\n\n.tabslistsection {\n  max-height: 70px;\n  background: #F2F2F2 0% 0% no-repeat padding-box;\n  overflow: hidden;\n  position: relative;\n  width: calc(100vw - 0.6vw);\n  left: 50%;\n  right: 50%;\n  margin-left: -50vw;\n  margin-right: -50vw;\n\n  \n  .tabslistrow {\n    padding-top: 20px;\n    margin-right: auto;\n    margin-left: 9%;//auto;\n    font-size: 18px;\n\n    @include respond-to (small) {\n      font-size: 8px !important;\n     margin-top:10px !important;\n     margin-left: 8px;\n    }\n\n  }\n\n  .tabitem {\n    margin-right: 45px; //70px;\n    padding-left: 0px;\n\n    @include respond-to (small) {\n      font-size: 14px;\n      margin-right: 30px;\n\n    }\n\n    \n    @media only screen and (max-width: 768px){\n      font-size: 12px;\n      margin-right: 3px; //30px;\n\n    }\n  }\n\n  .tabitem:hover {\n    cursor: pointer;\n  }\n\n  .tabline {\n    background-color: #0469AE;\n    padding-bottom: -20px;\n    opacity: 1;\n    width: 81px;\n    height: 5px;\n    margin-top: 25px;\n    margin-right: auto;\n    margin-left: 9%;//auto;\n    padding-left: 15px;\n    float: left;\n\n    @include respond-to (small) {\n      width: 0px;\n      border: 0px;\n      visibility: hidden;\n    }\n  }\n}\n\n.shortdescription {\n  padding-top: 52px;\n  max-width: 1217px;\n  margin-left: 100px;\n  \n  @include respond-to(small) {\n    padding-top: 14px;\n    font-size:18px;\n    margin-left: 10px;\n  }\n  @media only screen and (max-width: 768px){\n    font-size:14px;\n}\n}\n\n@include respond-to(small) {\n.title-heading {\n  margin-left: 10px !important;\n  margin-top: 10px !important;\n}\n}\n\n.shortdescription1{\n  padding-top:  15px;\n  max-width: 1217px;\n  margin-bottom: 30px;\n  padding-left: 8%;\n  @include respond-to(small) {\n    padding-top: 14px;\n    padding-left:3%;\n  }\n}\n\n:host ::ng-deep body {\n  font-size: 20pt/28pt !important;\n}\n\n.benefitsheader {\n  padding-top: 30px;\n  font-size: 28pt !important;\n  max-width: 50%;\n  float: left;\n  margin-left: 0%;\n\n  @include respond-to(small) {\n    max-width: 100%;\n    padding-top: 20px;\n  }\n\n  .benefitsheaderpara {\n    font-size: 30px;\n    float: left;\n    line-height: 23px;\n\n    @include respond-to (small) {\n      font-size: 28px;\n      max-width: 100%;\n    }\n    @media only screen and (max-width: 768px){\n      font-size:24px;\n  }\n  }\n}\n\n.benefits {\n  padding-top: -30px;\n  max-width: 1217px;\n  padding-bottom: 480px;\n  display: flexbox;\n  flex-direction: row;\n\n  @include respond-to (small) {\n    flex-direction: column;\n  }\n\n  .benefitstext {\n    padding-top: 20px;\n    float: left;\n    max-width: 701px;\n    margin-left: 0%;\n  }\n\n  .benefitstext .ul,\n  li {\n    list-style-type: disc;\n    list-style-position: outside;\n    font-size: 16px;\n    line-height: 28px;\n    margin-left: 14px;\n\n    @include respond-to(small) {\n      font-size: 16px;\n      line-height: 20px;\n    }\n  }\n\n  .benefitsimage {\n    float: right;\n    height: 390px;\n    width: 390px;\n\n    @include respond-to (small) {\n      height: 243px;\n      width: 343px;\n    }\n\n    .benefitsimagespec {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.subscriptionsection {\n  padding-top: 10px;\n  position: static;\n\n  @include respond-to (small) {\n    padding-top: 50%;\n  }\n\n  .subscriptioncontent {\n    max-width: 100%;\n    padding-top: 50px;\n    background-color: #F2F2F2;\n    opacity: 1;\n\n\n    .tabheading {\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      padding-top: 42.5px;\n      font-size: 28px;\n      letter-spacing: 0.81px;\n      color: #000000;\n      opacity: 100%;\n      font-weight: bold;\n\n      @include respond-to(small) {\n        font-size: 28px;\n      }\n    }\n\n    .subheading {\n      font-size: 16px;\n      text-align: center;\n      align-items: center;\n      justify-content: center;\n      margin-right: 1%;\n      margin-left: 1%;\n    }\n\n    .subscription-images {\n      margin: 0 15% 2% 10%;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n\n      .subscription-cards {\n       display: flex;\n       flex-direction: column;\n       width: 100%;\n       margin: 0px 20px;\n\n       .card-flex {\n         width: 102%;\n         margin-left: 20px;\n         margin-right: auto;\n       }\n\n      .subscription-card {\n        border: 1px solid #FFFFFF;\n        height: 100%;\n        background: #FFFFFF;\n        margin: 0 5% 0 5%;\n        text-align: center;\n        padding: 35px 15px 35px 15px;\n        width: 102%;\n\n\n        h2 {\n          font-size: 29px;\n          margin-bottom: 5px;\n        }\n\n        p {\n          font-size: 14px;\n          margin: 0 20px;\n          text-align: center;\n        }\n\n        .starting-text {\n          text-align: center;\n          font-size: 18px;\n          padding-top: 15px;\n          padding-bottom: 30px;\n        }\n\n        .starting-text1 {\n          text-align: center;\n          font-size: 18px;\n          padding-top: 0px;\n          padding-bottom: 30px;\n        }\n\n        .starting-text-second {\n          text-align: center;\n          font-size: 18px;\n          padding-top: 15px;\n          padding-bottom: 15px;\n        }\n        \n        .bold-price {\n          text-align: center;\n          font-size: 48px;\n          font-weight: 900;\n          padding-bottom: 20px;\n        }\n\n        .bold-pricing {\n          font-size: 32px;\n          font-weight: 900;\n          letter-spacing: 1.07px;\n          line-height: 30px;\n          margin: 0 20px;\n        }\n\n        .devices-no {\n          text-align: center;\n          font-size: 18px;\n          font-weight: 900;\n          margin-bottom: 50px;\n        }\n\n        .plan-list {\n          font-size: 19px;\n          width: 60%;\n          text-align: center;\n          padding-bottom: 40px;\n          margin: 0 20%;\n        }\n\n        .plan-lists-div {\n          padding: 35px 0 0 0;\n        }\n\n        .plan-lists {\n          font-size: 18px;\n          margin: 0 20px;\n          text-align: justify;\n        }\n\n      }\n\n    }\n    }\n\n    @include respond-to('small') {\n      .subscription-images {\n        flex-direction: column;\n        margin: 0 5% 2% 5%;\n       .subscription-cards {\n         width: 100%;\n         margin: 15px 0 15px 0;\n\n         .card-flex {\n           width: 102%;\n           margin-left: auto;\n         }\n        .subscription-card {\n          margin: 0;\n\n           h2 {\n             font-size: 22px;\n           }\n\n           p {\n             font-size: 16px;\n           }\n\n           .starting-text, .starting-text-second {\n             font-size: 14px;\n           }\n\n           .bold-price {\n             font-size: 44px;\n           }\n\n           .devices-no {\n             font-size: 18px;\n           }\n\n           .plan-list {\n             font-size: 13px;\n           }\n\n           .bold-pricing {\n             font-size: 28px;\n           }\n\n           .plan-lists {\n             font-size: 16px;\n             margin: 0px;\n           }\n        }\n      }\n      }\n    }\n   \n    .subscription-fiveg-images {\n      margin-left: 90px;\n      margin-top: 10px;\n      display: flex; \n      flex-flow: row wrap;\n      position: relative;\n\n      .subscription-fiveg-cards {\n      text-align: left;\n      float: left;       \n      margin: 10px 60px 10px 40px;\n      flex: 0 1 calc(20% - 8px);\n  \n       .card-flex {\n         width: 100%;\n         margin-right: auto;\n       }\n\n      .subscription-fiveg-card {\n        border: 1px solid #FFFFFF;\n        height: 100%;\n        background: #FFFFFF;\n        width: 250px;\n\n        h2 {\n          margin-top: 10px;\n          font-size: 28px;\n          margin-bottom: 5px;\n          text-align: center;\n          font-weight: bold;\n        }\n        .subscription-sub-content{\n          font-size: 14px;\n          height: 70px;\n          margin: 10px 10px 10px 10px;\n          text-align: center;\n        }\n\n        .subscription-descheading{\n          text-align: start;\n          font-size: 18px;\n          margin-top:  10px ;\n          margin-left: 10px;\n        }\n        \n        .subscription-desc-content{\n          text-align: start;\n          margin-top:  10px ;\n          margin-left: 10px;\n          font-size: 14px;\n          height: 140px;\n          line-height: 24px;\n        }\n\n        .subscription-goodheading{\n          text-align: start;\n          font-size: 18px;\n          margin-top:  20px ;\n          margin-left: 10px;\n        }\n\n        .keyfeatures{\n          margin-top: 10px;\n          margin-left: 12px;\n          font-size: 14px;\n          height: 120px; \n\n          ul, li {\n            margin-left: 2px;\n            list-style: disc outside none;\n            font-size: 14px;\n            line-height: 24px;\n          }\n        \n            @include respond-to(small) {\n              font-size: 12px;\n              line-height: 20px;\n              }\n        }\n\n        .request-solution{\n          margin-left: 40px;\n          margin-top: 30px;\n        }\n\n        @include respond-to(small) {\n        .request-solution{\n          margin-left: 24%;\n          margin-top: 30px;\n        }\n      }\n    \n        .bold-price {\n          text-align: start;\n          margin-top:  10px ;\n          margin-left: 10px;\n          font-size: 14px;\n        }\n\n        .devices-no {\n          text-align: center;\n          font-size: 18px;\n          font-weight: 900;\n          margin-top: 30px;\n        }\n\n        .sub-notes {\n          padding-top: 40px;\n          text-align: center;\n        }\n\n        .note-heading{\n          font-weight: bold;\n        }\n\n        .plan-list {\n          font-size: 19px;\n          width: 60%;\n          text-align: center;\n          margin-top: 40px;          \n        }\n\n        .plan-lists-div {\n          padding: 35px 0 0 0;\n        }\n\n        .plan-lists {\n          font-size: 18px;\n          margin: 0 20px;\n          text-align: justify;\n        }\n\n      }\n\n    }\n    }\n\n    @include respond-to('small') {\n      .subscription-fiveg-images {\n        flex-direction: column;\n        margin: 0 5% 2% 5%;\n       .subscription-fiveg-cards {\n         width: 100%;\n         margin: 15px 0 15px 0;\n\n         .card-flex {\n           width: 100%;\n           margin-left: auto;\n         }\n        .subscription-fiveg-card {\n          margin: 0;\n          width:100%;\n          padding:7px;\n           h2 {\n             font-size: 22px;\n           }\n\n           p {\n             font-size: 16px;\n           }\n\n           .starting-text, .starting-text-second {\n             font-size: 14px;\n           }\n\n           .bold-price {\n             font-size: 44px;\n           }\n\n           .devices-no {\n             font-size: 18px;\n           }\n\n           .plan-list {\n             font-size: 13px;\n           }\n\n           .bold-pricing {\n             font-size: 28px;\n           }\n\n          //  .subscription-desc-content {\n          //    height: 0px !important;\n          //  }\n\n           .plan-lists {\n             font-size: 16px;\n             margin: 0px;\n           }\n        }\n      }\n      }\n    }\n\n    .subimages {\n      margin-left: 20%;\n      margin-right: 20%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n      padding-bottom: 10px;\n\n      @include respond-to (small) {\n        flex-direction: column;\n      }\n    }\n\n    .subimage {\n      margin-left: 10px;\n      margin-right: 10px;\n      height: 440px;\n      width: 390px;\n\n      @include respond-to (small) {\n        height: 300px;\n        width: 300px;\n        padding-bottom: 10px;\n      }\n    }\n\n    .subeligiblebox {\n      background: #106FBA 0% 0% no-repeat padding-box;\n      margin-top: 15px;\n    }\n\n    .subeligibletext {\n      padding-top: 10px;\n      padding-bottom: 10px;\n      margin-left: 10%;\n      margin-right: 10%;\n      max-width: 70%;\n      text-align: center;\n      font-size: 12px;\n      color: #ffffff;\n      opacity: 100%;\n    }\n  }\n}\n\n.detailsection {\n  padding-top: 15px;\n  max-width: 100%;\n  padding-bottom: 10px;\n  display: flexbox;\n  flex-direction: row;\n  margin-left: 100px !important;\n\n  @include respond-to(small) {\n    flex-direction: column;\n    margin-left: 0px !important;\n\n  }\n\n  .detailsheader {\n    max-width: 30%;\n    margin-left: 5%;\n    font-size: 30px;\n    line-height: 40px;\n    float: left;\n    letter-spacing: 0.81px;\n    color: #000000;\n    opacity: 1;\n    margin: -5px;\n\n    @include respond-to(small) {\n      font-size: 28px;\n      margin-left: 20px;\n      float: none;\n    }\n    @media only screen and (max-width: 768px){\n      font-size: 24px;\n      margin-left: 20px;\n      float: none;\n  }\n  }\n}\n\n.outerboxwithsmallfont {\n  margin-left: 25%;\n  margin-right: 2%;\n  padding-bottom: 10px;\n  font-size: 14px;\n\n  @include respond-to(small) {\n    padding-top: 10px;\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n}\n\n.outerbox {\n  margin-left: 25%;\n  margin-right: 2%;\n  padding-bottom: 20px;\n\n  @include respond-to(small) {\n    padding-top: 10px;\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n}\n\n.outerbox{\n  ul, li {\n    list-style: disc outside none;\n    font-size: 16px;\n    line-height: 28px;\n    margin-left: 8px;\n\n    @media screen and (max-width: 1024px){\n      font-size: 16px;//8px;\n      }\n    }\n\n    @include respond-to(small) {\n      font-size: 16px;\n      line-height: 20px;\n      }\n\n      @media only screen and (max-width: 768px){\n        font-size:14px;\n    }\n      \n}\n\n.plan-fiveg-note {\n  text-align: center;\n  font-style: italic;\n}\n\n.overview {\n  @media screen and (max-width: 1024px){\n  margin-left: 10px !important;\n  }\n}\n\n.smallbox {\n  float: left;\n  margin-left: 0%;\n  margin-right: 15px;\n  padding-bottom: 55px;\n\n  @include respond-to(small) {\n    margin-left: 15%;\n  }\n\n  .line {\n    border: 3px solid #52B6EB;\n    background-color: #52B6EB;\n    opacity: 1;\n    width: 183px;\n\n    @include respond-to (small) {\n      width: 183px;\n    }\n  }\n\n  .smalltext {\n    padding-top: 7px;\n    padding-bottom: 20px;\n    text-align: left;\n    width: 183px;\n    font-size: 16px;\n\n    @include respond-to (small) {\n      width: 183px;\n      font-size: 16px;\n    }\n  }\n}\n\n.largebox {\n  float: left;\n  margin-left: 0%;\n  margin-right: 5%;\n  width: 350px;\n  // height: 168px;\n\n  @include respond-to(small) {\n    width: 335px;\n  }\n\n  .line {\n    border: 3px solid #52B6EB;\n    background-color: #52B6EB;\n    opacity: 1;\n    width: 380px;\n\n    @include respond-to(small) {\n      width: 320px;\n    }\n    @media screen and (max-width: 1024px){\n      width: 100%;//250px\n    }\n  }\n\n  .largetext {\n    padding-top: 7px;\n    padding-bottom: 7px;\n    padding-left: 5px;\n    text-align: left;\n    width: 380px;\n    font-size: 16px;\n\n    @include respond-to(small) {\n      font-size: 16px;\n      // width: 320px;\n    }\n    @media screen and (max-width: 768px){\n      font-size: 16px;\n      width: 100%; //70%;\n      }\n  }\n}\n\n.rightbox {\n  margin-top: -20px;\n  @include respond-to(small) {\n    margin-top: 0px;\n  }\n}\n.appleReq{\n  margin-left: 100px !important;\n  @include respond-to(small) {\n    margin-left: 0px !important;\n  }\n}\n\n\n.requirementsection {\n  padding-top: 15px;\n  max-width: 100%;\n  padding-bottom: 15px;\n  display: flexbox;\n  flex-direction: row;\n\n  @include respond-to(small) {\n    flex-direction: column;\n    margin-left: 0px !important;\n  }\n\n  .requirementsheader {\n    max-width: 20%;\n    margin-left: 5%;\n    font-size: 30px;\n    line-height: 40px;\n    float: left;\n    letter-spacing: 0.81px;\n    color: #000000;\n    opacity: 1;\n    margin: -5px;\n\n    @include respond-to(small) {\n      font-size: 28px;\n      max-width: 70%;\n      margin-left: 20px;\n      float: none;\n    }\n\n    @media only screen and (max-width: 768px){\n      font-size:24px;\n  }\n  }\n}\n\n  .usecases-section {\n   padding-top: 15px;\n   max-width: 100%;\n   padding-bottom: 10px;\n   padding-left: 9%;\n  }\n    .usecasesHeading {\n      font-size: 28px;\n      line-height: 40px;\n      float: left;\n      letter-spacing: 0.81px;\n      font-weight: bold;\n      padding-left: 0%;\n    }\n    .usecasesDesc {\n      margin-top: 50px;\n    }\n    .mat-expansion-indicator  {\n      margin-right: 67px;\n     margin-top: 20px;\n     margin-bottom: 10px;\n     color: #1D83D9;\n     width: 20px;\n    }\n    .mat-expansion-panel-header :focus, \n    .mat-expansion-panel-header :focus-within, \n    .mat-expansion-panel-header:focus-visible {\n      background-color: lightgrey !important;\n    }\n\n    .usecasesDetails {\n      margin-left: 100px;\n      margin-top: 10px;\n      margin-bottom: 30px;\n      display: flex;\n      flex-flow: row wrap;\n      position: relative;\n      align-items: baseline;  \n      height: 100% !important;   \n      padding: 0 !important;\n      @include respond-to(small) {\n        margin-left:10px !important\n        }\n    }\n    .usecase-cards {\n      border: 1px solid #000000;\n      margin-left: 80px;     \n      margin-top: 30px;\n      width:230px;\n    }\n    .image-icon {\n      margin-top:  10px ;\n      margin-left: 90px;\n\n      }\n    .usecase-subheading {\n      font-size: 18px;\n      margin-top:  20px ;\n      margin-left: 10px;\n      text-align: center;\n    }\n    .usecase{\n      margin-left: 14px;\n      height: 149px;\n      margin-top: 10px;\n      font-size: 14px; \n      ul,li {\n        list-style: disc outside none;\n        font-size: 14px;\n       line-height: 24px;\n      }\n       \n    }\n\n\n.EasyDeployHeader {\n  max-width: 25%;\n  margin-left: 5%;\n  font-size: 28px;\n  line-height: 40px;\n  float: left;\n  letter-spacing: 0.81px;\n  color: #000000;\n  opacity: 1;\n  margin: -5px;\n  display: flex;\n  \n\n  @include respond-to(small) {\n    font-size: 20px;\n    max-width: 70%;\n    margin-left: 20px;\n    float: none;\n  }\n}\n\n.easyDeployNote{\n  margin-top: 10px;\n  margin-bottom:  25px;\n  float: right;\n  font-size: 14px;\n  // margin-right: 100px;\n\n  @media screen and (max-width: 1024px){\n    margin-left:21px !important;\n  }\n}\n\n.alert {\n  margin: 20px;\n  border-radius: 8px;\n}\n\n.alert div:first-child {\n  border-radius: 8px 0 0 8px;\n}\n\n.submitting {\n  height: 50px;\n  margin-left: 45%;\n  width: 50px;\n}\n\n.success-msg {\n  color: #007a3d;\n  margin: 5px;\n  font: 24px/25px 'Omnes-ATT-W02-Light';\n}\n\n.buttons-section {\n  height: 115px;\n  margin-bottom: 100px;\n  max-width: 681px;\n}\n\n// banner section starts here\n.mar-top-20 {\n  margin-top: 50px;\n  margin-left: 60px !important;\n}\n\n@media only screen and (max-width: 768px){\n  .mar-top-20 {\n    margin-top: 60px;\n    margin-left: 4px;\n    margin-right: -4px;\n  }\n}\n.banner-section {\n  align-items: center;\n  height: 500px;\n  overflow: hidden;\n  position: relative;\n  width: calc(100vw - 0.6vw);\n  left: 50%;\n  right: 50%;\n  margin-left: -50vw;\n  margin-right: -50vw;\n\n  .banner-caption {\n    @include vendor-prefix('transform', translateY(-50%));\n    left: 0;\n    padding-left: 10px;\n    position: absolute;\n    top: 50%;\n    width: 100%;\n\n    #bannerNameSection {\n      color: white;\n      margin-bottom: 5px;\n      margin-top: 5px;\n      line-height: 40px;\n      letter-spacing: 1.11px;\n      text-align: left;\n      max-width: 70%;\n\n      @include respond-to(small) {\n        font-size: 28px;\n        line-height: 28px;\n        letter-spacing: 0.47px;\n        margin-top: 57px;\n        max-width: 70%;\n        margin-bottom: 17px;\n      }\n      @media only screen and (max-width: 768px){\n        font-size: 18px;\n        line-height: 18px;\n        letter-spacing: 0.47px;\n        margin-top: 20px;\n        max-width: 70%;\n      }\n      \n    }\n    #proDesc{\n        color:#52B6EB;\n    } \n\n    #whiteBannerName {\n      color:white;\n      margin-bottom: 5px;\n      margin-top: 5px;\n      line-height: 40px;\n      letter-spacing: 1.11px;\n      opacity: 1;\n      text-align: left;\n      max-width: 90%;\n    \n      @include respond-to(small) {\n        font-size: 28px;\n        line-height: 22px;\n        letter-spacing: 0.47px;\n        max-width: 70%;\n        margin-top: 45px;\n      }\n    }\n\n    #lightBannerNameSection{\n      @include respond-to(small) {\n        font-size: 28px;\n      }\n      @media only screen and (max-width: 768px){\n        font-size:18px;\n    }\n    }\n\n    .lightBannerNameSection {\n      color: #000000;\n      margin-bottom: 5px;\n      margin-top: 5px;\n      line-height: 40px;\n      letter-spacing: 1.11px;\n      opacity: 1;\n      text-align: left;\n      max-width: 70%;\n\n      @include respond-to(small) {\n        font-size: 17px;\n        line-height: 19px;\n        letter-spacing: 0.47px;\n        max-width: 70%;\n        margin-top: 20px;\n      }\n    }\n\n    .product-text {\n      margin-left: -15px;\n      margin-right: -15px;\n      width: 100%;\n      max-width: 480px;\n      color: white;\n      font-size: 18px;\n\n      @include respond-to(small) {\n        margin-left: -15px;\n        margin-right: -15px;\n        font-size: 18px;\n        width: 100%;\n        line-height: 18px;\n      }\n      @media only screen and (max-width: 768px){\n        margin-left: -15px;\n        margin-right: -15px;\n        font-size: 12px;\n        width: 100%;\n        line-height: 12px;\n      }\n    }\n\n    .checkboxText {\n      @include respond-to(small) {\n        font-size: 10px;\n        margin-right: 151px;\n      }\n    }\n\n    .white-product-text {\n      margin-left: -15px;\n      margin-right: -15px;\n      width: 100%;\n      max-width: 480px;\n      text-align: left;\n      letter-spacing: 0.48px;\n      color:white;\n      opacity: 1;\n      @include respond-to(small) {\n        margin-left: -15px;\n        margin-right: -15px;\n        font-size: 10px;\n        width: 70%;\n        line-height: 12px;\n      }\n    }\n\n    .light-product-text {\n      margin-left: -15px;\n      margin-right: -15px;\n      width: 100%;\n      max-width: 480px;\n      text-align: left;\n      letter-spacing: 0.48px;\n      color: #000000;\n      opacity: 1;\n      font-size: 18px;\n\n      @include respond-to(small) {\n        margin-left: -15px;\n        margin-right: -15px;\n        font-size: 18px;\n        width: 100%;\n        line-height: 18px;\n      }\n\n      @media only screen and (max-width: 768px){\n        font-size:12px;\n    }\n    }\n  }\n\n  img {\n    left: 50%;\n    max-width: 1920px;\n    position: absolute;\n    // width: 100%;\n    transform: translateX(-50%);\n    // top: -400px;\n    @media only screen and (max-width: 1024px ){\n      transform: translateX(0%) !important;\n      left: 0% !important;\n      max-width: 1024px !important;\n      position: absolute;\n      top: 0px !important;\n    }\n  }\n  \n}\n\n.hide-small {\n  display: block;\n  visibility: visible !important;\n}\n\n.show-small {\n  display: none;\n  visibility: hidden;\n}\n\n.productImage {\n  opacity: unset !important;\n}\n\n@media (max-width: 767px) {\n\n  .hide-small {\n    display: none;\n    visibility: hidden;\n  }\n\n  .show-small {\n    display: block;\n    visibility: visible !important;\n  }\n}\n\n@include respond-to(small) {\n  .details-page {\n    padding-bottom: 10px;\n  }\n\n  .banner-section {\n    align-items: center;\n    height: auto;\n    overflow: hidden;\n    position: relative;\n    margin-top: 50px;\n\n    figure {\n      height: 250px;\n      overflow: hidden;\n      position: relative;\n      margin-inline-end: 0px;\n      margin-bottom: -50px;\n    }\n\n    img {\n      left: 50%;\n      width: auto;\n      max-width: 1024px;\n      position: absolute;\n      transform: translateX(-50%);\n    }\n\n    .banner-caption {\n      left: 0;\n      padding-left: 0;\n      top: 40%;\n\n      h1 {\n        font-size: 17px;\n        font-weight: bold;\n        margin-bottom: 10px;\n        margin-top: 20px;\n      }\n\n      p {\n        margin-bottom: 10px;\n      }\n\n      .firstnetErrorMessageLink {\n        color: #0000EE;\n        text-decoration: none;\n        outline: none;\n    }\n\n\n      // .product-text,\n      // .light-product-text {\n      //   margin-left: -15px;\n      //   margin-right: -15px;\n      //   font-size: 10px;\n      //   width: 70%;\n      //   line-height: 12px;\n      // }\n\n      .btn-secondary {\n        font-size: 12px;\n      }\n\n      h2.product-style {\n        margin-bottom: 10px !important;\n      }\n    }\n  }\n}\n\n// banner section end hereß\n//program link color changes\n.program a {\n  color: #191919 !important;\n}\n\n#banner-section-light figure {\n    height: 600px;\n    width: 100vw;\n    background: black;\n    overflow: hidden;\n}\n\n#banner-section-light img {\n  object-fit: cover;\n   opacity: 0.5;\n}\n\n@include respond-to(small) {\n  #banner-section-light figure {\n    height: 237px;\n    width: 100vw;\n    background: black;\n    overflow: hidden;\n}\n\n#banner-section-light img {\n  object-fit: none;\n   opacity: unset;\n}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
